module.exports = __webpack_public_path__ + "img/katarina_outside_21.2649b6d0.jpg";